import styled, { css } from 'styled-components';
import { Maybe, StyledComponent, StyledSpanComponent } from '../types';

export const iconMapping = {
  pdf: '\\e900',
  position: '\\e901',
  question: '\\e902',
  reloaded: '\\e903',
  ring_bell: '\\e904',
  sendMail: '\\e905',
  share_full: '\\e906',
  share_outline: '\\e907',
  smartphone: '\\e908',
  thumb_up: '\\e909',
  twitter_old: '\\e90a',
  user: '\\e90b',
  information_outline: '\\e90c',
  letter: '\\e90d',
  information_full: '\\e90e',
  arrow_full: '\\e90f',
  arrow: '\\e910',
  book: '\\e911',
  calender: '\\e912',
  calling_full: '\\e913',
  calling_outline: '\\e914',
  check: '\\e915',
  search: '\\e917',
  close: '\\e918',
  eye: '\\e919',
  facebook: '\\e91a',
  favourits: '\\e91b',
  fax: '\\e91c',
  arrowUp: '\\e91d',
  clock: '\\e91e',
  bookmark: '\\e91f',
  star: '\\e920',
  images: '\\e921',
  bin: '\\e922',
  mail: '\\e923',
  contact: '\\e924',
  linkedin: '\\e925',
  fax_outline: '\\e926',
  financing: '\\e927',
  vehicle: '\\e928',
  share_outline_thin: '\\e929',
  twitter: '\\e92a',
};

export type FontIconKey = keyof typeof iconMapping;

export interface FontIconProps {
  icon: FontIconKey;
  arrow?: 'left' | 'right';
  rotation?: number;
  iconSize?: string;
  offsetY?: string;
}

export const getFontIconKey = (key = ''): Maybe<FontIconKey> => {
  if (key in iconMapping) {
    return key as FontIconKey;
  }
  return null;
};

export const FontIcon: StyledComponent<FontIconProps> = styled.i`
  &:before {
    position: relative;
    display: inline-block;
    font-family: 'busstore-icons';
    font-style: normal !important;
    font-weight: normal !important;
    text-decoration: inherit;
    text-rendering: auto;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;

    ${(props) => props.offsetY ? `top: ${props.offsetY};` : ''}

    ${(props) => props.iconSize ? `font-size: ${props.iconSize};` : ''}

    text-decoration: none;

    content: "${(props: FontIconProps) => iconMapping[props.icon]}";
    margin-right: 5px;

    ${(props) => props.rotation ? `transform: rotate(${props.rotation}deg);` : ''}

    ${(props: FontIconProps) =>
      props.arrow &&
      css`
        display: inline-block;
        font-size: 14px;

        ${props.arrow === 'right' &&
          css`
            transform: rotate(-90deg);
          `};
      `}
  }
`;

export const FontIconSpan: StyledSpanComponent<
  FontIconProps
> = FontIcon.withComponent('span');
